import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      d="M4.98 4.979a.5.5 0 0 1 .67-.035l.037.035 5.333 5.333.035.038a.5.5 0 0 1-.704.704l-.038-.035L4.98 5.686l-.034-.038a.5.5 0 0 1 .034-.67"
      color="#EE2049"
    />
    <path
      d="M10.351 4.944a.5.5 0 0 1 .704.704l-.035.038-5.333 5.333a.5.5 0 0 1-.707-.707l5.333-5.333z"
      color="#EE2049"
    />
  </svg>
);
export default SvgSmallX;
